/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sd_Description_Length_LabelInputs */



/**
* | output |
* | --- |
* | "Scene Description Length" |
*
* @param {Sd_Description_Length_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sd_description_length_label = /** @type {((inputs?: Sd_Description_Length_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sd_Description_Length_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description de la scène Durée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Szenenbeschreibung Länge")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione della scena Lunghezza")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание сцены (длительность)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción de la escena (longitud)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("场景描述长度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("シーン描写の長さ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दृश्य विवरण लंबाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição da cena Duração")
	return /** @type {LocalizedString} */ ("Scene Description Length")
});